export default __webpack_public_path__ + "static/media/new-hackdfw-skyline.5a4e9bff.png";